import { DemandRightsContentVo } from "#services/api";
import { isNumber } from 'lodash';

interface Params {
  current: number;
  limit: number;
  status?: number;
  content_fuzzy?: string;
  category_ids?: number[],
}

const queryDemandRightsPageContentList = (params: Params, rightsList: DemandRightsContentVo[]) => {
  let list = rightsList?.map(v => ({
    ...v,
    actual_content: v.content,
    rights_code: v.code,
  })) || [];
  const { current, limit, status, content_fuzzy, category_ids } = params;

  if (content_fuzzy) {
    list = list.filter(v => v.content.includes(content_fuzzy));
  }

  if (category_ids?.length) {
    list = list.filter(v => category_ids.includes(v.category_id || v.category_parent_id));
  }

  if (isNumber(status)) {
    list = list.filter(v => status === v.status);
  }

  const total_count = list.length;

  return Promise.resolve({
    data: {
      list: list.slice((current - 1) * limit, current * limit),
      total_count,
    }
  })
}

export {
  queryDemandRightsPageContentList
};